import Model from './Model'

export default class Team extends Model
{
    static async all () {
        const { data } = await Http.get(route('api.v1.teams.index'))
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.teams.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.teams.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.teams.destroy', this.id))
    }
}
